function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M408.1 347.8L295 234.7l113.1-113.1c12.5-12.5 12.5-32.8 0-45.3L393 61.2c-12.5-12.5-32.8-12.5-45.3 0l-113 113.1L121.5 61.2c-12.5-12.5-32.8-12.5-45.3 0l-15 15.1c-12.5 12.5-12.5 32.8 0 45.3l113.1 113.1L61.2 347.8c-12.5 12.5-12.5 32.8 0 45.3l15.1 15.1c12.5 12.5 32.8 12.5 45.3 0L234.7 295l113.1 113.1c12.5 12.5 32.8 12.5 45.3 0l15.1-15.1c12.4-12.4 12.4-32.7-.1-45.2z"
});
function SvgUnfollow(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 469.3 469.3",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
export default __webpack_public_path__ + "772e2412585622c13d5a7e93c442474d.svg";
export { SvgUnfollow as ReactComponent };